import DOMPurify from 'dompurify'

const sanitizeConfig = {
  ADD_ATTR: ['style', 'target', 'rel', 'class'],
  FORBID_TAGS: ['style'],
  ALLOW_DATA_ATTR: false
}

// Değerler tarayıcının CSS ayrıştırıcısından geçtikten sonra (kaçış dizileri çözülmüş hâlde) kontrol ediliyor.
const BLOCKED_STYLE_VALUE = /(url|image-set|-webkit-image-set|expression|element)\s*\(/i
const BLOCKED_STYLE_PROPERTIES = new Set(['behavior', '-moz-binding'])
const LINK_TAGS = new Set(['A', 'AREA'])

function decodeHtmlEntities (value) {
  if (typeof document === 'undefined') {
    return value
  }

  // textarea içeriği RCDATA olarak ayrıştırılır: element oluşmaz, sadece entity'ler çözülür.
  const textarea = document.createElement('textarea')
  textarea.innerHTML = value
  return textarea.value
}

function sanitizeInlineStyle (node) {
  const style = node.style
  if (!style) {
    node.removeAttribute('style')
    return
  }

  for (let i = style.length - 1; i >= 0; i--) {
    const property = style[i]
    const value = style.getPropertyValue(property)
    const isOverlayPosition = property === 'position' && /fixed|sticky/i.test(value)

    if (BLOCKED_STYLE_PROPERTIES.has(property) || BLOCKED_STYLE_VALUE.test(value) || isOverlayPosition) {
      style.removeProperty(property)
    }
  }

  if (!style.length) {
    node.removeAttribute('style')
  }
}

if (!DOMPurify.__coridorRichTextHookAdded) {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.hasAttribute?.('target')) {
      if (LINK_TAGS.has(node.tagName)) {
        node.setAttribute('rel', 'noopener noreferrer')
      } else {
        node.removeAttribute('target')
      }
    }

    if (node.hasAttribute?.('style')) {
      sanitizeInlineStyle(node)
    }
  })
  DOMPurify.__coridorRichTextHookAdded = true
}

export function sanitizeHtml (value) {
  return DOMPurify.sanitize(decodeHtmlEntities(value || ''), sanitizeConfig)
}
